// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__1XcRn","closeIcon":"Toast_closeIcon__3R4R4","appearToast":"Toast_appearToast__3QdEZ"};